'use client';

import { useEffect } from 'react';

export default function ClientAuditTracker() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Inicializar Google Ads específicamente para el auditor
      const adsScript = document.createElement('script');
      adsScript.type = 'text/javascript';
      adsScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-17161209946/8ChpCOK7ieYaENqQjfc_');

        window.gtag_report_audit = function(url) {
          gtag('event', 'custom_audit', {
              'send_to': 'AW-17161209946/8ChpCOK7ieYaENqQjfc_'
          });
        }
      `;
      document.body.appendChild(adsScript);

      // Observar cambios en el DOM para rastrear el botón de Análisis
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            // Buscar el botón que dice "Analyze Website"
            const analyzeButtons = document.querySelectorAll('button');
            analyzeButtons.forEach(button => {
              if (button.textContent?.trim() === 'Analyze Website') {
                // Remover cualquier evento existente
                (button as HTMLButtonElement).removeEventListener('click', handleAuditClick);
                // Agregar evento una sola vez
                (button as HTMLButtonElement).addEventListener('click', handleAuditClick, { once: true });
              }
            });
          }
        });
      });

      // Función para manejar el clic
      const handleAuditClick = () => {
        if (typeof window.gtag_report_audit === 'function') {
          // Evitar múltiples envíos
          window.gtag_report_audit();
          // Deshabilitar el botón temporalmente
          const button = document.querySelector('button:contains("Analyze Website")') as HTMLButtonElement;
          if (button) {
            button.disabled = true;
            setTimeout(() => {
              button.disabled = false;
            }, 3000); // Restaurar después de 3 segundos
          }
        }
      };

      // Función para verificar y restaurar el estado del botón
      const checkButtonState = () => {
        const button = document.querySelector('button:contains("Analyze Website")') as HTMLButtonElement;
        if (button && button.disabled) {
          button.disabled = false;
        }
      };

      // Observar cambios en el DOM
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Observar cambios en el DOM
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Cleanup on unmount
      return () => {
        document.body.removeChild(adsScript);
        observer.disconnect();
      };
    }
  }, []);

  return null;
}
